import { Dialog } from '@factorialco/factorial-one-react/dist/experimental'
import { Delete } from '@factorialco/factorial-one-react/icons/app'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import useDeleteElement from 'modules/forms/hooks/useDeleteElement'

type Props = {
  open: boolean
  onClose: () => void
  formId: string
  elementId: string
  resourceId: string
  resourceType: string
}

const DeleteDialog = ({ open, onClose, formId, elementId, resourceId, resourceType }: Props) => {
  const { deleteElement } = useDeleteElement(formId)
  const onDelete = async () => {
    const response = await deleteElement({ id: elementId, resourceId, resourceType })
    if (response) {
      const result = handleResult(response, () => {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('common.error'),
        })
      })

      if (result.success) {
        onClose()
      }
    }
  }

  return (
    <Dialog
      onClose={onClose}
      open={open}
      actions={{
        primary: {
          icon: Delete,
          label: i18n.t('forms.editor.delete_dialog.remove_action'),
          onClick: onDelete,
          variant: 'critical',
        },
        secondary: {
          label: i18n.t('forms.editor.delete_dialog.cancel_action'),
          onClick: onClose,
        },
      }}
      header={{
        description: i18n.t('forms.editor.delete_dialog.message'),
        title: i18n.t('forms.editor.delete_dialog.title'),
        type: 'critical',
      }}
    />
  )
}
export default DeleteDialog
